import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ALLOWED_HOSTS, BREAKPOINTS, UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { Blog } from '@sparro/app/core/models/blog.model';
import { ImageMetaData } from '@sparro/app/core/models/media.model';
import { environment } from '@sparro/env/environment';


@Component({
  selector: 'uni-blog-card-image',
  templateUrl: './blog-card-image.component.html',
  styleUrls: ['./blog-card-image.component.scss']
})
export class BlogCardImageComponent implements OnInit {
  @Input() blog: Blog;
  @Input() featured: boolean = false;
  @Input() self: boolean;
  @Input() host: ALLOWED_HOSTS;
  @Input() dialogOpenable: boolean = true;
  @Input() isDisplay: boolean
  @Input() cardWidth: number = null;
  @Output() openDialogEvent = new EventEmitter();

  isDesktop: boolean = true;

  hasImageBadge: boolean = false;
  blogImageMetaData: ImageMetaData;
  defaultImage = UNI_CONSTANTS.NO_IMAGE.JOURNAL;

  constructor(
    public breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit() {
    if (this.host === UNI_CONSTANTS.HOSTS.BLOG ||
      this.host === UNI_CONSTANTS.HOSTS.ARENA ||
      (this.host === UNI_CONSTANTS.HOSTS.PROFILE && this.blog.status !== 'DRAFT' )
    ) {
      this.hasImageBadge = true;
    }
    if (this.isDisplay == true){
      this.isDesktop = false
    }
    else {
      this.initializeBreakpoints();
    }
  }

  initializeBreakpoints() {
    const tabletBreakpoint = BREAKPOINTS.below.md;
    this.breakpointObserver.observe([tabletBreakpoint]).subscribe(
      result => {
        this.isDesktop = !result.breakpoints[tabletBreakpoint];
      }
    );
  }

  openDialog(): boolean {
    if (this.dialogOpenable) {
      this.openDialogEvent.emit();
    }
    return !this.dialogOpenable;
  }

  getBlogDetailLink(): string {
    if (this.host === UNI_CONSTANTS.HOSTS.EVALUATION) {
        return `${environment.evalUrl}/${this.blog.chamber_id}/journal/${this.blog.id}`;
    } else {
      if (this.blog.slug) {
        return `${environment.postUrl}${this.blog.slug}`;
      } else if (this.self || this.blog.status === 'DRAFT') {
        return `${environment.postUrl}edit/${this.blog.uuid}/`;
      }
    }
  }

}
